import { useState } from "react";
import { groupMembersText } from "./announcement-text.ts";
import { Crumbs } from "../shell/Crumbs.tsx";

/**
 * Шапка окна переписки: путь наверх и состав группы.
 *
 * ⚠️ **Своим файлом, а не куском окна** (правка по итогам итогового ревью
 * 30.08.2026, порог в 400 строк из раздела 9 CLAUDE.md). Обе части не читают ни
 * одного состояния окна и не двигают его: им дают строку и список имён. Всё, что
 * осталось в `ConversationPage.tsx`, про страницы, прокрутку и свежесть.
 */

/**
 * Хлебные крошки. Ссылкой, а не кнопкой «назад»: это переход по адресу, и его
 * обязано быть видно в строке браузера и можно открыть в новой вкладке.
 *
 * Рисуется и до того, как окно приехало: у ожидания и у отказа путь наверх
 * обязан быть тем же самым, поэтому имя разговора передаётся отдельно и до
 * ответа сервера его нет.
 */
export function ConversationCrumbs(props: { here: string | null }) {
  return <Crumbs trail={[{ label: "Сообщения", to: "/announcements" }]} here={props.here} />;
}

/**
 * Кто в этой группе.
 *
 * ⚠️ **Стоит в шапке ОКНА, а не под каждым сообщением** (решение владельца
 * 30.08.2026). До окна переписки состав жил в карточке одного объявления и
 * отвечал на вопрос «кому это ушло»; здесь вопрос другой, «кто в этой группе», и
 * ответ на него один на всё окно.
 *
 * ⚠️ **Имена приезжают готовыми и своей подстановки здесь нет ни одной.** Какие
 * именно приедут, решил сервер по читателю: преподавателю из его списка
 * учеников, ученику внутригрупповые. Личное окно списка не получает вовсе, и
 * ветки под него тут нет: собеседник там один, и он же в заголовке.
 *
 * ⚠️ **Свёрнуто по умолчанию, и это не украшение.** В рассылочном списке
 * участников бывает шестьдесят, и развёрнутый список отодвинул бы переписку за
 * край экрана у того, кто пришёл читать сообщения. Число видно сразу, имена по
 * нажатию.
 */
export function ConversationMembers(props: { names: string[] }) {
  const [open, setOpen] = useState(false);
  const label = groupMembersText(props.names.length);
  if (label === null) return null;

  return (
    <div className="chat__who">
      <button
        type="button"
        className="btn btn--quiet"
        aria-expanded={open}
        onClick={() => setOpen(!open)}
      >
        {label}
      </button>
      {/* Именами через запятую, а не списком: это одна строка справки о группе,
          и превращать её в столбик значит показывать состав громче переписки */}
      {open && <p className="chat__names">{props.names.join(", ")}</p>}
    </div>
  );
}
